import { TANGERINE_DREAM } from 'Modules/Shared/constants/colors';

const secondary = {
  main: TANGERINE_DREAM,
};

export default secondary;
